import { useNavigate } from "react-router-dom";
import HeaderBar from "../../../Components/UI/headerbar";
import CourierTab from "../../../Components/shipping/CourierTab";


const DriversPage = () => {
  const navigate = useNavigate();
;

  const handleNavigate = () => {
      navigate(`${process.env.PUBLIC_URL}/shipping/store-curior`);    
  };


  return (
    <div className="container-fluid">
      <HeaderBar
        title={"التوصيل"}
        content={
          "إدارة شركات الشحن المرتبطة بالنظام، يمكنك عرض بيانات الشركات والسائقين المرتبطين بهم."
        }
      />
      <CourierTab onAddClick={handleNavigate} />;
    </div>
  );
};

export default DriversPage;
